import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_2 = { class: "list-table-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "control is-flex is-align-items-center" }
const _hoisted_6 = { class: "has-text-centered mt-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_breadcrumb, {
        size: "is-large",
        separator: "has-succeeds-separator",
        "aria-label": "breadcrumbs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_breadcrumb_item, { active: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('projects.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'project-gallery' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('projects.addNew')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_table, {
        data: _ctx.rows,
        striped: "",
        loading: _ctx.loading,
        onClick: _ctx.handleRowClick,
        "sort-icon": "menu-up",
        "default-sort": "name",
        "default-sort-direction": "asc"
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('projects.noneYet')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_b_table_column, {
            field: "name",
            sortable: "",
            label: _ctx.$t('projects.name')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "updatedAt",
            sortable: "",
            label: _ctx.$t('projects.lastUpdated')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.$d(new Date(props.row.updatedAt), 'short')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "firmwareSha",
            sortable: "",
            label: _ctx.$t('projects.latestFirmware')
          }, {
            default: _withCtx((props) => [
              (props.row.firmwareSha)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_component_router_link, {
                      to: { name: 'firmware-details', params: { sha: props.row.firmwareSha } },
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      class: "is-family-monospace"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.shortSha(props.row.firmwareSha)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "lastBuildAt",
            sortable: "",
            label: _ctx.$t('projects.lastSuccessfulBuild')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.lastBuildAt ? _ctx.$d(new Date(props.row.lastBuildAt), 'short') : '—'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            label: _ctx.$t('global.action')
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_b_button, {
                  type: "is-danger",
                  size: "is-small",
                  "icon-left": "delete",
                  title: _ctx.$t('global.delete'),
                  "aria-label": "delete",
                  onClick: _withModifiers(($event: any) => (_ctx.confirmRemove(props.row)), ["stop"])
                }, null, 8, ["title", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "loading", "onClick"])
    ])
  ]))
}